<!--字段配置Ec-->
<template>
  <div class="field-setting">
    <el-form label-width="380px" label-position="left" @keyup.enter.native="submitForm('formFiled')">
      <el-form-item label="客户模板" prop="userName">
        <el-select
          v-model="form.crmTemplateId"
          filterable
          clearable
          placeholder="请选择模板">
          <el-option
            v-for="item in list" :key="item.templateId"
            :label="item.templateName"
            :value="item.templateId" />
        </el-select>
      </el-form-item>
      <div class="button">
        <el-button type="primary" size="small" @click="submitForm('formFiled')">保存</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
  import Api from '@/api/client/template-setting'
  export default {
    props: {
      origin: {
        type: String
      }
    },
    data () {
      return {
        list: [],
        form: {}
      }
    },
    created () {
      this.getList()
      this.getInfo()
    },
    methods: {
      getList () {
        const form = {
          crmCode: this.origin,
          type: 1
        }
        Api.getList({form}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.list = body.list
          } else {
            this.$message.error(body.error)
          }
        })
      },
      getInfo () {
        const form = {
          crmCode: this.origin,
          type: 1
        }
        Api.getInfo({form}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.form = body
          } else {
            this.$message.error(body.error)
          }
        })
      },
      submitForm (formName) {
        const form = this.form
        Api.submit({form}, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            // this.getFounder()
            this.$message.success('保存成功！')
          } else {
            this.$message.error(body.error)
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .field-setting .el-form-item__label{
    padding-left:68px;
  }
</style>

<style scoped lang="scss">
.field-setting{
  margin-top:5px;
  .goSetting{
    color:#606266;
    font-size: 14px;
    margin:0 0 20px;
    span{
      color:#FF0000;
      padding-right:5px;
    }
  }
  .field-menu{
    border-bottom:1px solid rgba(235,238,245,1);
    margin-bottom:20px;
    padding-bottom:15px;
    span{
      display: inline-block;
      font-size:14px;
      font-weight:bold;
      color:#666;
      &:nth-child(1){
        margin-left:68px;
      }
      &:nth-child(2){
        margin-left:330px;
      }
    }
  }
  .el-input{
    width:50%;
  }
  .button{
    text-align: center;
    margin-top:60px;
    button{
      // width:100px;
      height:35px;
      line-height:1;
      background:rgba(8,94,204,1);
      border-radius:4px;
      padding: 0 30px;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/crm/TempSetting.vue